import ReactDOM from 'react-dom';
import ManageYourPasskeysPage from  '@/components/page/manage/ManageYourPasskeysPage';
import { GrantTypeService } from '@/services/grantType.service';



const ManageYourPasskeysPortal = () =>  {
    const targetContainer = document.getElementById('react-manage-your-passkeys-page');

    // this is a global service, so only set it for portals that exist
    if(targetContainer) {
        GrantTypeService.setIsMfaSession(
            targetContainer?.dataset.isMfaSession === 'True'
        ) 
    }
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(<ManageYourPasskeysPage />, targetContainer);
}
export default ManageYourPasskeysPortal;